import * as t from "io-ts";
import nullable from "./nullable";
import { placeT } from "./place";
export const customerDeliveryLocationT = t.strict({
    id: t.string,
    clientId: t.string,
    number: t.string,
    name: t.string,
    address: nullable(t.string),
    barred: nullable(t.boolean),
    country: nullable(t.string),
    city: nullable(t.string),
    postalCode: nullable(t.string),
    resolvedPlace: nullable(placeT),
    searchedForCoordinates: t.boolean,
});
export const customerDeliveryLocationsT = t.array(customerDeliveryLocationT);
export const customerDeliveryLocationUpdateT = t.intersection([
    t.strict({
        name: t.string,
        address: nullable(t.string),
        postalCode: nullable(t.string),
        city: nullable(t.string),
        country: nullable(t.string),
    }),
    t.partial({
        resolvedPlace: placeT,
    }),
]);
export const customerDeliveryLocationCreateT = t.intersection([
    t.strict({
        name: t.string,
        address: nullable(t.string),
        postalCode: nullable(t.string),
        city: nullable(t.string),
        country: nullable(t.string),
    }),
    t.partial({
        resolvedPlace: placeT,
    }),
]);
//# sourceMappingURL=customer-delivery-location.js.map